function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.7515 18.007L13.1082 1.99731C12.7775 1.38216 12.1613 1 11.5001 1C10.8392 1 10.2233 1.38172 9.89255 1.99621L1.24798 18.0081C0.91734 18.6233 0.91734 19.3875 1.24798 20.0027C1.57862 20.6178 2.19483 21 2.8561 21H20.144C20.8052 21 21.4215 20.6178 21.7521 20.0027C22.0827 19.3875 22.0827 18.6233 21.7515 18.007ZM20.6866 19.3419C20.575 19.5495 20.3671 19.6784 20.144 19.6784H2.8561C2.633 19.6784 2.42507 19.5495 2.31351 19.3419C2.20196 19.1344 2.20196 18.8765 2.3129 18.67C2.3129 18.67 10.9572 2.65854 10.9574 2.65815C11.069 2.45061 11.2769 2.32167 11.5 2.32167C11.7231 2.32167 11.9311 2.45061 12.0432 2.65929L20.6866 18.6689C20.7982 18.8765 20.7982 19.1344 20.6866 19.3419Z",
  fill: "currentColor"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5001 10.4273C11.1603 10.4273 10.8849 10.7232 10.8849 11.0881V13.7313C10.8849 14.0962 11.1603 14.3921 11.5001 14.3921C11.8398 14.3921 12.1152 14.0962 12.1152 13.7313V11.0881C12.1152 10.7232 11.8398 10.4273 11.5001 10.4273Z",
  fill: "currentColor"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5001 17.0353C11.8398 17.0353 12.1152 16.7394 12.1152 16.3745C12.1152 16.0095 11.8398 15.7137 11.5001 15.7137C11.1603 15.7137 10.8849 16.0095 10.8849 16.3745C10.8849 16.7394 11.1603 17.0353 11.5001 17.0353Z",
  fill: "currentColor"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M21.7515 18.007L13.1082 1.99731C12.7775 1.38216 12.1613 1 11.5001 1C10.8392 1 10.2233 1.38172 9.89255 1.99621L1.24798 18.0081C0.91734 18.6233 0.91734 19.3875 1.24798 20.0027C1.57862 20.6178 2.19483 21 2.8561 21H20.144C20.8052 21 21.4215 20.6178 21.7521 20.0027C22.0827 19.3875 22.0827 18.6233 21.7515 18.007ZM20.6866 19.3419C20.575 19.5495 20.3671 19.6784 20.144 19.6784H2.8561C2.633 19.6784 2.42507 19.5495 2.31351 19.3419C2.20196 19.1344 2.20196 18.8765 2.3129 18.67C2.3129 18.67 10.9572 2.65854 10.9574 2.65815C11.069 2.45061 11.2769 2.32167 11.5 2.32167C11.7231 2.32167 11.9311 2.45061 12.0432 2.65929L20.6866 18.6689C20.7982 18.8765 20.7982 19.1344 20.6866 19.3419Z",
  stroke: "currentColor",
  strokeWidth: 0.5
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5001 10.4273C11.1603 10.4273 10.8849 10.7232 10.8849 11.0881V13.7313C10.8849 14.0962 11.1603 14.3921 11.5001 14.3921C11.8398 14.3921 12.1152 14.0962 12.1152 13.7313V11.0881C12.1152 10.7232 11.8398 10.4273 11.5001 10.4273Z",
  stroke: "currentColor",
  strokeWidth: 0.5
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5001 17.0353C11.8398 17.0353 12.1152 16.7394 12.1152 16.3745C12.1152 16.0095 11.8398 15.7137 11.5001 15.7137C11.1603 15.7137 10.8849 16.0095 10.8849 16.3745C10.8849 16.7394 11.1603 17.0353 11.5001 17.0353Z",
  stroke: "currentColor",
  strokeWidth: 0.5
});
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.3fa22253aab8055fcfb4b407f27a6483.svg";
export { ForwardRef as ReactComponent };